import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CashBookSummary } from 'src/app/models/CashBookSummary';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HrCashBookService {

  
  constructor(private httpClient: HttpClient) { }

  ServiceUrl: string = environment.BaseServiceUrl + "HrCashBook";

  public getCashBookSummary(): Observable<CashBookSummary> {
    let url = this.ServiceUrl + '/Summary';
    return this.httpClient.get<CashBookSummary>(url);
  }
}
